import React, {useState, useEffect, useRef} from 'react';
import styles from './ListKupon.module.css';
import { getCupons, deleteCupon, GetLibrat, increaseStock, searchKupon } from '../../server/server';

const ListKupon = () => {
  const [tickets, setTickets] = useState([]);
  const [limit, setLimit] = useState(7);
  const [librat, setLibrat] = useState([]);
  const searchinput = useRef(null);

  useEffect(()=>{
    getCupons().then((res)=> {
      setTickets(res.result);
    });

    GetLibrat().then((res)=> {
      setLibrat(res.result)
    });
  }, [])
  useEffect(() => {
    
  }, [tickets])
  

  const moreList = () => {
    if (tickets.length > limit) {
      setLimit(limit + 7);
    }
  };

  const deleteHandleBtn = (id, isbn) => {
    let currentStock = 1;

    librat.map((liber) => {
      if(liber.isbn === isbn){
        currentStock = liber.stock + 1;
      }
    });
    deleteCupon(id);
    increaseStock(isbn, currentStock);
  };

  const kerko = () => {
    const toSearch = searchinput.current.value;
    if(toSearch === ""){
      getCupons().then((res)=> {
        setTickets(res.result)
      })
    }else{
      searchKupon(toSearch).then((res)=> {
        setTickets(res.resu);
      })
    }
  }

  if(tickets === []){
    return(
      <div>
        Loading...
      </div>
    );
  }else{

    return (
      <div>
        <head>
          <title>Alert Page - Xtreme Starter Next Js App</title>
          <meta name="description" content="Generated by create next app" />
          <link rel="icon" href="/favicon.ico" />
        </head>
        <div>
          <p className={styles.title}>Lista e Kuponave</p>
          <div className={styles.searchBar}>
            <input
              className={styles.input}
              type="text"
              placeholder="Search for a book"
              ref={searchinput}
            />
            <br />
            <div onClick={kerko} className={styles.btn}>Kerko</div>
          </div>
          {/* book list */}
          <div>
            {tickets.map((ticket, i) => {
              return (
                i < limit && (
                  <div key={i} className={styles.bookItem}>
                    <div className={styles.itemInfo}>
                      <p>Emri: {ticket.emri}</p>
                      <p>BookId: {ticket.isbn}</p>
                    </div>
                    <div className={styles.itemSituation}>
                      <p>Data Marrjes: {ticket.dataEMarrjes}</p>
                      <p>Data Kthimit: {ticket.dataEKthimit}</p>
                    </div>
                    <div
                      onClick={() => deleteHandleBtn(ticket._id, ticket.isbn)}
                      className={styles.button}
                    >
                      Delete
                    </div>
                  </div>
                )
              );
            })}
            <div onClick={moreList} className={styles.loadMore}>
              <p>Listo me shume Libra</p>
            </div>
          </div>
  
          {/* list end */}
        </div>
      </div>
    )
  }

}

export default ListKupon;